<ng-container
  *ngIf="
    hrefType === HrefType.ANGULAR_ROUTE ||
      hrefType === HrefType.EXTERNAL ||
      hrefType === HrefType.OPEN_MODAL_VIDEO;
    else noRouterLink
  "
>
  <!-- Special Links -->
  <a
    *ngIf="isSpecialLink(href) || inModal"
    class="special-link"
    [attr.href]="href"
    [attr.data-type]="type"
    [attr.data-viewport]="viewport"
    [attr.data-disabled]="disabled"
    [attr.rel]="rel || 'nofollow'"
    [attr.target]="target"
    [attr.title]="title || label"
    [ngStyle]="{ color: color }"
    [ngClass]="size"
  >
    <hdi-icon
      *ngIf="inModal"
      [iconName]="
        isPhoneLink(href) ? 'phone' : isEmailLink(href) ? 'envelope' : 'globe'
      "
      [color]="Colors.GREEN"
      [size]="Sizes.LARGE"
    ></hdi-icon>
    <div class="special-link__content">
      <span
        *ngIf="overLabel && isPhoneLink(href)"
        class="special-link__content__over-label"
        >{{ overLabel }}</span
      >
      <h5
        *ngIf="inModal; else outsideModal"
        class="special-link__content__label"
        [innerHTML]="isPhoneLink(href) ? label : overLabel"
      ></h5>
      <ng-template #outsideModal>
        <span
          class="special-link__content__label special-link__content__label--outside-modal"
          [innerHTML]="label"
        ></span>
      </ng-template>
    </div>
  </a>
  <!-- Angular Route Links -->
  <a
    *ngIf="
      hrefType === HrefType.ANGULAR_ROUTE && !isSpecialLink(href) && !inModal
    "
    [routerLink]="normalizeHref(href)"
    [fragment]="fragment && fragment.trim() !== '' ? fragment : undefined"
    [attr.data-type]="type"
    [attr.data-viewport]="viewport"
    [attr.data-disabled]="disabled"
    [attr.rel]="rel || (fragment ? 'canonical' : 'follow')"
    [attr.target]="'_self'"
    [attr.title]="title || label"
    [ngStyle]="{ color: color }"
    [ngClass]="size"
  >
    <hdi-icon
      *ngIf="
        type === LinkType.SECONDARY_ICON ||
        type === LinkType.SECONDARY_ICON_LIGHT ||
        type === LinkType.DOWNLOAD ||
        type === LinkType.DOWNLOAD_NO_UNDERSCORED
      "
      [iconName]="getIconName()"
      [iconPrefix]="getIconPrefix()"
      [size]="sizes || Sizes.SMALL"
    />
    <span
      [innerHTML]="label"
      [attr.data-viewport]="viewport"
      [ngStyle]="{ 'font-weight': bold ? 'bold' : '' }"
    ></span>
    <hdi-icon
      *ngIf="shouldDisplayRightIcon()"
      [iconName]="getIconName()"
      [iconPrefix]="getIconPrefix()"
      [size]="sizes || Sizes.SMALL"
    />
  </a>
  <!-- External Links -->
  <a
    *ngIf="hrefType === HrefType.EXTERNAL && !isSpecialLink(href) && !inModal"
    [attr.href]="!disabled ? href : '#'"
    [attr.data-type]="type"
    [attr.data-viewport]="viewport"
    [attr.data-disabled]="disabled"
    [attr.rel]="rel || 'noopener noreferrer'"
    [attr.target]="'_blank'"
    [attr.title]="title || label"
    [ngStyle]="{ color: color }"
    [ngClass]="size"
  >
    <span
      [innerHTML]="label"
      [attr.data-viewport]="viewport"
      [ngStyle]="{ 'font-weight': bold ? 'bold' : '' }"
    ></span>
    <hdi-icon
      *ngIf="shouldDisplayRightIcon()"
      [iconName]="getIconName()"
      [iconPrefix]="getIconPrefix()"
      [size]="sizes || Sizes.SMALL"
    />
  </a>
  <!-- Download Links -->
  <a
    *ngIf="
      hrefType === HrefType.EXTERNAL &&
      type === (LinkType.DOWNLOAD || LinkType.DOWNLOAD_NO_UNDERSCORED)
    "
    download
    [attr.href]="!disabled ? href : '#'"
    [attr.data-type]="type"
    [attr.data-viewport]="viewport"
    [attr.data-disabled]="disabled"
    [attr.rel]="'noopener noreferrer'"
    [attr.target]="'_self'"
    [attr.title]="title || label"
    [ngStyle]="{ color: color }"
    [ngClass]="size"
  >
    <span
      [innerHTML]="label"
      [attr.data-viewport]="viewport"
      [ngStyle]="{ 'font-weight': bold ? 'bold' : '' }"
    ></span>
    <hdi-icon
      *ngIf="shouldDisplayRightIcon()"
      [size]="sizes || Sizes.SMALL"
      [iconName]="getIconName()"
      [iconPrefix]="getIconPrefix()"
    />
  </a>
  <!-- Internal Links -->
  <!-- <a
    *ngIf="hrefType === HrefType.ANGULAR_ROUTE && !isSpecialLink(href)"
    [attr.href]="generateFullHref()"
    [class.active]="isActiveLink()"
[attr.data-type]="type"
  [attr.data-viewport]="viewport"
  [attr.data-disabled]="disabled"
  [attr.rel]="rel ||fragment ? 'canonical' : 'follow'"
  [attr.target]="target || (hrefType === HrefType.EXTERNAL ? '_blank' : '_self')"
  [attr.title]="title || label"
  [ngStyle]="{ color: color }"
  [ngClass]="size"
  >
    <hdi-icon
      *ngIf="
        type === LinkType.SECONDARY_ICON ||
        type === LinkType.SECONDARY_ICON_LIGHT ||
        type === LinkType.DOWNLOAD ||
        type === LinkType.DOWNLOAD_NO_UNDERSCORED
      "
      [iconName]="getIconName()"
      [iconPrefix]="getIconPrefix()"
      [size]="Sizes.SMALL"
    />
    <span [innerHTML]="label" [attr.data-viewport]="viewport"[ngStyle]="{ 'font-weight': bold ? 'bold' : 'normal' }"></span>
    <hdi-icon
      *ngIf="shouldDisplayRightIcon() "
      [iconName]="getIconName()"
      [iconPrefix]="getIconPrefix()"
      [size]="Sizes.SMALL"
    />
  </a> -->
  <!-- Modal Links -->
  <a
    *ngIf="hrefType === HrefType.OPEN_MODAL_VIDEO"
    (click)="openModal($event)"
    [attr.data-type]="type"
    [attr.data-viewport]="viewport"
    [attr.data-disabled]="disabled"
    [attr.rel]="'nofollow'"
    [attr.target]="'_self'"
    [attr.title]="title || label"
    [ngStyle]="{ color: color }"
    [ngClass]="size"
  >
    <hdi-icon
      *ngIf="
        type === LinkType.SECONDARY_ICON ||
        type === LinkType.SECONDARY_ICON_LIGHT ||
        type === LinkType.DOWNLOAD ||
        type === LinkType.DOWNLOAD_NO_UNDERSCORED
      "
      [iconName]="getIconName()"
      [iconPrefix]="getIconPrefix()"
    />
    <span
      [innerHTML]="label"
      [attr.data-viewport]="viewport"
      [ngStyle]="{ 'font-weight': bold ? 'bold' : '' }"
    ></span>
    <hdi-icon
      *ngIf="shouldDisplayRightIcon()"
      [iconName]="getIconName()"
      [iconPrefix]="getIconPrefix()"
    />
    <!-- Moved in app.component.html -->
    <!-- <hdi-modal
      *ngIf="video"
      [showModal]="showModal || video.videoId === videoId"
      [type]="ModalType.VIDEO"
      [videoSrc]="video.videoSrc"
      [videoId]="video.videoId"
      [thumbnailSrc]="video.thumbnailSrc"
      (closeModalTrigger)="closeModal($event)"
    >
      <div class="header-content">
        <ng-content select=".header-content"></ng-content>
      </div>
      <ng-content></ng-content>
    </hdi-modal> -->
  </a>
</ng-container>

<!-- Navbar Links -->
<ng-template #noRouterLink>
  <a
    *ngIf="hrefType === HrefType.OPEN_FLYOUT"
    (click)="openFlyout.emit({ href: href, label: label })"
    [attr.data-type]="type"
    [attr.data-viewport]="viewport"
    [attr.data-disabled]="disabled"
    [attr.rel]="rel || 'nofollow'"
    [attr.target]="target || '_self'"
    [attr.title]="title || label"
    [ngStyle]="{ color: color }"
    [ngClass]="size"
    [innerHTML]="label"
  >
    <hdi-icon
      *ngIf="
        type === LinkType.SECONDARY_ICON ||
        type === LinkType.SECONDARY_ICON_LIGHT ||
        type === LinkType.DOWNLOAD ||
        type === LinkType.DOWNLOAD_NO_UNDERSCORED
      "
      [iconName]="getIconName()"
      [iconPrefix]="getIconPrefix()"
    />
    <span [innerHTML]="label" [attr.data-viewport]="viewport"></span>
    <hdi-icon
      *ngIf="shouldDisplayRightIcon()"
      [iconName]="getIconName()"
      [iconPrefix]="getIconPrefix()"
    />
  </a>
</ng-template>
